/* eslint-disable react/button-has-type */
import { useDispatch } from 'react-redux';
import { allBlogs } from '../redux/filters/actions';

export default function Button() {
    const dispatch = useDispatch();
    const handleAllBlogs = () => {
        dispatch(allBlogs());
    };

    return (
        <button
            className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded mt-2"
            onClick={handleAllBlogs}
        >
            All Blogs
        </button>
    );
}
